import { useCallback, useEffect, useRef, RefObject } from 'react';
import { API, Endpoints } from '@brg/api';
import { useFingerprintId, useProfileId } from '@brg/auth';
import { useBreakpoint } from '@brg/ui';
import { LayoutConst } from 'core';
import { IContentViewItem } from './useContentView';

// AdActionType (бэк): Impression = 0, Click = 1
const AD_ACTION_TYPE_IMPRESSION = 0;
const AD_ACTION_TYPE_CLICK = 1;
// AdActionEntityType (бэк): Project = 1, Card = 2, Book = 3, Team = 4 — рекламные блоки показываются на странице проекта
const AD_ACTION_ENTITY_TYPE_PROJECT = 1;
// deviceType (бэк): Desktop = 0, Mobile = 1
const AD_ACTION_DEVICE_TYPE_DESKTOP = 0;
const AD_ACTION_DEVICE_TYPE_MOBILE = 1;

interface UseContentViewTrackingParams {
  adItem: IContentViewItem | null | undefined;
  projectId?: string;
  position: 0 | 1;
  elementRef: RefObject<HTMLElement>;
  componentName?: string;
}

interface UseContentViewTrackingResult {
  trackClick: () => void;
}

export const useContentViewTracking = ({
  adItem,
  projectId,
  position,
  elementRef,
  componentName,
}: UseContentViewTrackingParams): UseContentViewTrackingResult => {
  const hasSentViewRef = useRef(false);
  const visibilityTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const accountId = useProfileId();
  const fingerprint = useFingerprintId();
  const isMobile = useBreakpoint(LayoutConst.screen.s - 1);

  const sendAdAction = useCallback((actionType: number) => {
    if (!projectId || !adItem?.id || !fingerprint) return;

    return API.request()
      .endpoint(Endpoints.additionalcontent)
      .url('/api/Ad/AdAction')
      .post()
      .body({
        adId: adItem.id,
        actionType,
        сategory: 0,
        url: window.location.href,
        accountId: accountId ?? '',
        actionEntityType: AD_ACTION_ENTITY_TYPE_PROJECT,
        entityId: projectId,
        position,
        localTime: new Date().toISOString(),
        fingerprint,
        deviceType: isMobile ? AD_ACTION_DEVICE_TYPE_MOBILE : AD_ACTION_DEVICE_TYPE_DESKTOP,
      })
      .send();
  }, [adItem?.id, projectId, position, fingerprint, accountId, isMobile]);

  const trackClick = useCallback(() => {
    if (!adItem?.id || !fingerprint) return;
    const storageKey = `ad_click_${adItem.id}_${position}_${fingerprint}`;
    if (localStorage.getItem(storageKey)) return;
    localStorage.setItem(storageKey, '1');

    sendAdAction(AD_ACTION_TYPE_CLICK)?.catch((error) => {
      localStorage.removeItem(storageKey);
      console.error(`[${componentName}] Error sending ad click:`, error);
    });
  }, [sendAdAction, componentName, adItem?.id, position, fingerprint]);

  useEffect(() => {
    hasSentViewRef.current = false;

    const element = elementRef.current;
    if (!element || !projectId || !adItem?.id || !fingerprint) return;

    const sendContentViewRequest = () => {
      if (hasSentViewRef.current) return;

      hasSentViewRef.current = true;

      sendAdAction(AD_ACTION_TYPE_IMPRESSION)?.catch((error) => {
        console.error(`[${componentName}] Error sending content view:`, error);
        hasSentViewRef.current = false;
      });
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const { isIntersecting, intersectionRatio, boundingClientRect } = entry;

          const viewportHeight = window.innerHeight;
          const isTallBlock = boundingClientRect.height > viewportHeight;

          const isVisible = isTallBlock
            ? isIntersecting
            : intersectionRatio >= 0.99;

          if (isVisible) {
            if (!visibilityTimerRef.current) {
              visibilityTimerRef.current = setTimeout(() => {
                sendContentViewRequest();
                observer.unobserve(element);
              }, 1000);
            }
          } else {
            if (visibilityTimerRef.current) {
              clearTimeout(visibilityTimerRef.current);
              visibilityTimerRef.current = null;
            }
          }
        });
      },
      {
        threshold: [0, 1],
      }
    );

    observer.observe(element);

    return () => {
      observer.disconnect();
      if (visibilityTimerRef.current) {
        clearTimeout(visibilityTimerRef.current);
      }
    };
  }, [adItem?.id, projectId, position, fingerprint, sendAdAction, componentName]);

  return { trackClick };
};
import { useCallback, useEffect, useRef, RefObject } from 'react';
import { API, Endpoints } from '@brg/api';
import { useFingerprintId, useProfileId } from '@brg/auth';
import { useBreakpoint } from '@brg/ui';
import { LayoutConst } from 'core';
import { IContentViewItem } from './useContentView';

// AdActionType (бэк): Impression = 0, Click = 1
const AD_ACTION_TYPE_IMPRESSION = 0;
const AD_ACTION_TYPE_CLICK = 1;
// AdActionEntityType (бэк): Project = 1, Card = 2, Book = 3, Team = 4 — рекламные блоки показываются на странице проекта
const AD_ACTION_ENTITY_TYPE_PROJECT = 1;
// deviceType (бэк): Desktop = 0, Mobile = 1
const AD_ACTION_DEVICE_TYPE_DESKTOP = 0;
const AD_ACTION_DEVICE_TYPE_MOBILE = 1;

interface UseContentViewTrackingParams {
  adItem: IContentViewItem | null | undefined;
  projectId?: string;
  position: 0 | 1;
  elementRef: RefObject<HTMLElement>;
  componentName?: string;
}

interface UseContentViewTrackingResult {
  trackClick: () => void;
}

export const useContentViewTracking = ({
  adItem,
  projectId,
  position,
  elementRef,
  componentName,
}: UseContentViewTrackingParams): UseContentViewTrackingResult => {
  const hasSentViewRef = useRef(false);
  const visibilityTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const accountId = useProfileId();
  const fingerprint = useFingerprintId();
  const isMobile = useBreakpoint(LayoutConst.screen.s - 1);

  const sendAdAction = useCallback((actionType: number) => {
    if (!projectId || !adItem?.id || !fingerprint) return;

    return API.request()
      .endpoint(Endpoints.additionalcontent)
      .url('/api/Ad/AdAction')
      .post()
      .body({
        adId: adItem.id,
        actionType,
        сategory: 0,
        url: window.location.href,
        accountId: accountId ?? '',
        actionEntityType: AD_ACTION_ENTITY_TYPE_PROJECT,
        entityId: projectId,
        position,
        localTime: new Date().toISOString(),
        fingerprint,
        deviceType: isMobile ? AD_ACTION_DEVICE_TYPE_MOBILE : AD_ACTION_DEVICE_TYPE_DESKTOP,
      })
      .send();
  }, [adItem?.id, projectId, position, fingerprint, accountId, isMobile]);

  const trackClick = useCallback(() => {
    if (!adItem?.id || !fingerprint) return;
    const storageKey = `ad_click_${adItem.id}_${position}_${fingerprint}`;
    if (localStorage.getItem(storageKey)) return;
    localStorage.setItem(storageKey, '1');

    sendAdAction(AD_ACTION_TYPE_CLICK)?.catch((error) => {
      localStorage.removeItem(storageKey);
      console.error(`[${componentName}] Error sending ad click:`, error);
    });
  }, [sendAdAction, componentName, adItem?.id, position, fingerprint]);

  useEffect(() => {
    hasSentViewRef.current = false;

    const element = elementRef.current;
    if (!element || !projectId || !adItem?.id || !fingerprint) return;

    const sendContentViewRequest = () => {
      if (hasSentViewRef.current) return;

      hasSentViewRef.current = true;

      sendAdAction(AD_ACTION_TYPE_IMPRESSION)?.catch((error) => {
        console.error(`[${componentName}] Error sending content view:`, error);
        hasSentViewRef.current = false;
      });
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const { isIntersecting, intersectionRatio, boundingClientRect } = entry;

          const viewportHeight = window.innerHeight;
          const isTallBlock = boundingClientRect.height > viewportHeight;

          const isVisible = isTallBlock
            ? isIntersecting
            : intersectionRatio >= 0.99;

          if (isVisible) {
            if (!visibilityTimerRef.current) {
              visibilityTimerRef.current = setTimeout(() => {
                sendContentViewRequest();
                observer.unobserve(element);
              }, 1000);
            }
          } else {
            if (visibilityTimerRef.current) {
              clearTimeout(visibilityTimerRef.current);
              visibilityTimerRef.current = null;
            }
          }
        });
      },
      {
        threshold: [0, 1],
      }
    );

    observer.observe(element);

    return () => {
      observer.disconnect();
      if (visibilityTimerRef.current) {
        clearTimeout(visibilityTimerRef.current);
      }
    };
  }, [adItem?.id, projectId, position, fingerprint, sendAdAction, componentName]);

  return { trackClick };
};
